import { Link } from 'react-router-dom';

function HomeApproachSection() {
  return (
    <section className="band bg-navy" id="approach" aria-labelledby="approach-title">
      <div className="wrap">
        <div className="head-block center">
          <p className="eyebrow">Our Approach</p>
          <h2 className="section-title" id="approach-title" style={{ marginTop: '12px' }}>
            Two Frameworks Behind <span className="red">Every Program</span>
          </h2>
          <p className="section-sub">They&#39;re not theory - they&#39;re the actual thinking tools we use in every session. One sharpens architects and leaders. The other turns AI tools into reliable engineering partners.</p>
        </div>

        <div className="approach-grid">
          <div className="approach-col">
            <div className="kicker">For architects &amp; senior engineers</div>
            <h3>The SPARK Framework</h3>
            <p className="blurb">A decision-making engine - not a pattern library. Stop just coding and start architecting: spot the real problem, plan with intent, design for scale, build alignment, and present your vision to stakeholders.</p>
            <div className="spark-list">
              <div className="spark-item"><b>S - Spot the Problem</b><span>Uncover root causes across Business, Tech &amp; People.</span></div>
              <div className="spark-item"><b>P - Plan with Purpose</b><span>Define guiding principles and simplify complexity.</span></div>
              <div className="spark-item"><b>A - Architect for Scale</b><span>Design cohesive solutions with structure, clarity &amp; cohesion.</span></div>
              <div className="spark-item"><b>R - Rally for Impact</b><span>Drive consensus and govern your principles.</span></div>
              <div className="spark-item"><b>KS - Keynote with a Story</b><span>Sell your vision to stakeholders effectively.</span></div>
            </div>
          </div>

          <div className="approach-col">
            <div className="kicker">For developers working with AI</div>
            <h3>The 5W Framework</h3>
            <p className="blurb">GitHub Copilot often fails because developers don&#39;t know how to ask. The 5W Framework for Context Engineering is a structured method to stop hallucinating code and <span className="who">code 55% faster</span>.</p>
            <div className="fivew-list">
              <div className="fivew-item">
                <div className="fivew-ic">W.</div>
                <div>
                  <h4>The WHO &amp; WHAT</h4>
                  <p>Define the Persona (Who) and the exact Constraint (What) to get production-ready code instantly.</p>
                </div>
              </div>
              <div className="fivew-item">
                <div className="fivew-ic">W.</div>
                <div>
                  <h4>The WHERE &amp; WHEN</h4>
                  <p>Master placement - where to put your cursor and when to pull context from other files to guide Copilot&#39;s logic.</p>
                </div>
              </div>
              <div className="fivew-item">
                <div className="fivew-ic">W.</div>
                <div>
                  <h4>The WHY</h4>
                  <p>Understand the logic behind each suggestion so you never blindly commit broken code.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="center" style={{ marginTop: '44px' }}>
          <Link className="btn btn-red btn-pill" to="/architect">View the Full Syllabus</Link>
        </div>
      </div>
    </section>
  );
}

export default HomeApproachSection;
